import { create } from 'zustand';

const initialState = {
  notifications: {
    updates: [],
    totalCount: 0,
  },
};

const useNotificationsStore = create((set) => ({
  ...initialState,
  addNotifications: (newUpdates, totalCount) => {
    set((state) => {
      const deduplicatedUpdates = newUpdates.filter(
        (newNotification) =>
          !state.notifications.updates.some((existing) => existing.id === newNotification.id)
      );

      return {
        notifications: {
          ...state.notifications,
          updates: [...state.notifications.updates, ...deduplicatedUpdates],
          ...(totalCount !== undefined && { totalCount }),
        },
      };
    });
  },
  markAsRead: (id) => {
    set((state) => ({
      notifications: {
        ...state.notifications,
        updates: state.notifications.updates.map((notification) =>
          notification.id === id ? { ...notification, seen: true } : notification
        ),
      },
    }));
  },
  markAllAsRead: () => {
    set((state) => ({
      notifications: {
        ...state.notifications,
        updates: state.notifications.updates.map((notification) => ({ ...notification, seen: true })),
      },
    }));
  },
  clearNotifications: () => {
    set({
      notifications: {
        updates: [],
        totalCount: 0,
      },
    });
  },
  clearNotification: (id) => {
    set((state) => ({
      notifications: {
        ...state.notifications,
        updates: state.notifications.updates.filter((notification) => notification.id !== id),
        totalCount: Math.max(0, state.notifications.totalCount - 1),
      },
    }));
  },
  reset: () => set({ ...initialState })
}));

export default useNotificationsStore;
